var _react_refresh_temp_1;
var _react_refresh_temp_2, _react_refresh_temp_3;
_react_refresh_temp_2 = $RefreshSig$();
_react_refresh_temp_3 = $RefreshSig$();
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo, useState } from 'react';
import { TabContext } from './TabContext';
export const TabProvider = ({ children, initialTabId, useActiveTabStore = useActiveTabStoreFallback, }) => {
    _react_refresh_temp_2();
    const { activeTabId, setActiveTabId } = useActiveTabStore(initialTabId);
    const [focusedTabId, setFocusedTabId] = useState(null);
    const providerValue = useMemo(() => ({
        activeTabId,
        setActiveTabId,
        focusedTabId,
        setFocusedTabId,
    }), [activeTabId, focusedTabId, setActiveTabId]);
    return (_jsx(TabContext.Provider, { value: providerValue, children: children }));
};
_react_refresh_temp_1 = TabProvider;
$RefreshReg$(_react_refresh_temp_1, "TabProvider");
_react_refresh_temp_2(TabProvider, "MSU+b/PNv/P+0FxLu7BoE2nEuBI=", true);
const useActiveTabStoreFallback = (initialTabId) => {
    _react_refresh_temp_3();
    const [activeTabId, setActiveTabId] = useState(initialTabId);
    return { activeTabId, setActiveTabId };
};
_react_refresh_temp_3(useActiveTabStoreFallback, "azyACWVLASiAkCrNgjFVV5Itpkk=");
